import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowBarToUp = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "icon icon-tabler icons-tabler-outline icon-tabler-arrow-bar-to-up",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "none",
			d: "M0 0h24v24H0z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M12 10l0 10" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 10l4 4" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 10l-4 4" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 4l16 0" })
	]
});
export default SvgArrowBarToUp;
